/**
 * Discriminated subtypes + type guards for the activity types whose `data`
 * shape is fixed by system code (not user-defined). Lets both the backend and
 * the frontend narrow `Activity` into a properly-typed subtype without
 * repeating ad-hoc `typeof a.data?.X === 'string' ? ... : ''` checks at every
 * call site.
 *
 * Type guards are generic over the activity shape so they work with either
 * the wire format (`Activity` with ISO-string timestamps) or consumer-side
 * variants (e.g. the frontend's `Activity` with `Date` fields).
 *
 * Activity types not listed here (exercise, sleep, custom user-defined,
 * etc.) keep the generic `Activity` shape with `data?: Record<string, unknown>`.
 */
export const isMusicScrobbleActivity = (a) => a.activity_type === 'music_scrobble' &&
    typeof a.data?.artist === 'string' &&
    typeof a.data?.track === 'string';
export const isScreentimeActivity = (a) => a.activity_type === 'screentime' && typeof a.data?.category_path === 'string';
export const isLocationVisitActivity = (a) => a.activity_type === 'location_visit' &&
    typeof a.data?.lat === 'number' &&
    typeof a.data?.lon === 'number' &&
    typeof a.data?.location_name === 'string';
//# sourceMappingURL=activity-subtypes.js.map